import { Box, Flex, Text } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";
import Link from "next/dist/client/link";

function Calltoaction({ href, title = "" }) {
  const { t } = useTranslation("common");
  const style = {
    bgGradient: "linear(to-l, #7928CA, #FF0080)",
    color: "#fff",
    px: "20px",
    py: "10px",
    mt: "30px",
    pos: "fixed",
    overflow: "hidden",
    bottom: "0px",
    w: "100%",
    maxW: { base: "100%", md: "350px" },
    rounded: "15px 15px 0 0",
    right: "0",
    zIndex: "99",
  };
  return (
    <Box {...style}>
      <Flex justify="space-between" align="center">
        <Text mr="15px">{title === "" ? t("ctaTitle") : title}</Text>
        <Link href={href}>
          <a style={{ display: "block", flex: "0 0 100px" }}>
            <Box
              flex="0 0 100px"
              textAlign="center"
              fontSize="15px"
              fontWeight="bold"
              lineHeight="40px"
              bgColor="#fff"
              borderRadius="20px"
              cursor="pointer"
              color="#000"
            >
              {t("orderNow")}
            </Box>
          </a>
        </Link>
      </Flex>
    </Box>
  );
}

export default Calltoaction;
